import React from "react"

import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new"
import {FieldAutomationActionFormProps} from "../../../../render/automation-action-form";

const debug = false
// const debug = "DateActionForm"


export default class FieldDropdown_AutomationActionForm extends React.Component<FieldAutomationActionFormProps,any> {

    constructor(props:FieldAutomationActionFormProps) {
        super(props)

        this.state = {
            toValue: _.get(props.config, 'toValue', null)
        }
    }

    onChangeToValue = (option:any) => {
        const toValue = option ? option.value : null

        this.setState({
            toValue
        }, ()=>{
            this.props.onChangeCallback({toValue})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        const labelClasses = Classes("label", {
            'w-100': this.props.field.isCustom
        })

        return (
            <div className="flex-row-left-top">
                <div className={labelClasses}>to</div>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {this.props.field.getAutomationOptions()}
                                  value                         = {this.state.toValue}
                                  popoverScrollContainerClasses = "max-h-200"
                                  noValueOption                 = {this.props.field.noValueOption} // mykola 28.10 patched coz it was true
                                  isSearchable                  = {true}
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeToValue}/>
            </div>
        )
    }
}

